/**
 * @generated SignedSource<<652ae5b509e7b91e3993e3f2df6d7293>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoElementForm_VideoElementFragment$data = {
  readonly id: string;
  readonly title: string;
  readonly vimeoId: string;
  readonly " $fragmentType": "VideoElementForm_VideoElementFragment";
};
export type VideoElementForm_VideoElementFragment$key = {
  readonly " $data"?: VideoElementForm_VideoElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoElementForm_VideoElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoElementForm_VideoElementFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vimeoId",
      "storageKey": null
    }
  ],
  "type": "VideoElement",
  "abstractKey": null
};

(node as any).hash = "45629064ea4c568a71b25d4022afc866";

export default node;
